// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3cx3G","content":"RecentSearches_content__3cN9y"};